// remark: mimics builtin ES6 template literals, but with fallback
// Usage: 
//   var str = "Hello ${name} with number ${favNumber}!";
//   var interPolatedStr = interpolate(str, {name: 'John Doe', favNumber: 42}, 'fallback');
//     becomes => "Hello John Doe with number 42!"
//
//Samples:
//   interpolate("Hello World") // => "Hello World"
//   interpolate("Hello ${name} with number ${favNumber}!", null, '1337') // => "Hello ${name} with number ${favNumber}!"
//   interpolate("Hello ${name} with number ${favNumber}!", {}, '1337') // => "Hello 1337 with number 1337!"
//   interpolate("Hello ${name} with number ${favNumber}!", {"name": "John"}, '1337') // => "Hello John with number 1337!"
//   interpolate("Hello ${name} with number ${favNumber}!", {"name": "John", "favNumber": 42}, '1337') // => "Hello John with number 42!"
//   interpolate("Hello ${name} with number ${favNumber}!", {"name": "John" }) // => "Hello John with number undefined!"

export default (template, variables, fallback) => {
  var hasVariablesAnyValue = !!variables
  if (!template || !hasVariablesAnyValue) return template

  return template.replace(/\${[^{]+}/g, (match) => {
      const path = match.slice(2, -1).trim();
      return path
        .split('.')
        .reduce((res, key) => (res && key && (key in res) ? res[key] : fallback), variables)
  });
}

